import classNames from 'classnames';
import styles from './Checkbox.module.scss';

interface CheckboxProps {
  id: string;
  value?: boolean;
  label?: string;
  disabled?: boolean;
  onChange: (newValue: boolean) => void;
}
export const Checkbox = ({ id, value, label, disabled, onChange }: CheckboxProps) => (
  <label
    htmlFor={id}
    className={classNames(
      'block pl-8',
      styles.checkbox,
      disabled && 'text-gray-300',
      disabled ? 'cursor-not-allowed' : 'cursor-pointer'
    )}
  >
    {label}
    <input
      data-testid={`checkbox_${id}`}
      id={id}
      disabled={disabled}
      checked={value}
      type="checkbox"
      className={classNames('absolute mr-6 mt-2')}
      onChange={event => onChange(event.target.checked)}
    />
    <span className={classNames(styles.checkmark)} />
  </label>
);
